import axios from 'axios'
import { ref } from '@vue/composition-api'
import { saveAs } from 'file-saver'
import htmlDocx from 'html-docx-js';

export function Proposal() {
    // const availableFields = ref(['deskripsi', 'benefit', 'konfigurasi', 'slaslg', 'fitur']);
    const availableFields = ref([
        {
            val: 'deskripsi',
            label: 'Deskripsi',
        },
        {
            val: 'benefit',
            label: 'Benefit',
        },
        {
            val: 'konfigurasi',
            label: 'Konfigurasi',
        },
        {
            val: 'slaslg',
            label: 'SLA / SLG',
        },
        {
            val: 'fitur',
            label: 'Fitur',
        },
        {
            val: 'contact',
            label: 'Contact',
        },
    ]);
    const loading = ref(false)
    const selectedFields = ref([])
    async function generate(id, fields = ['all'], name = null) {
        fields = fields.join(',')
        loading.value = true
        return await axios.post(`https://productcatalog.telkom.co.id/generators/proposal/pdf` , {
            data: {
                kode: id,
                menu: fields
            }
        },
        {
            responseType: 'blob'
        })
        .then(res => {
            saveAs(res.data, name.replace(/[(.)]/g, '_') && `Proposal ${name.replace(/[(.)]/g, '_')}`)
        })
        .catch(err => console.error(err))
        .finally(() => loading.value = false)
    }
    return {
        generate,
        loading,
        availableFields,
        selectedFields,
    }
}

export function ProposalWord() {
    // const availableFields = ref(['deskripsi', 'benefit', 'konfigurasi', 'slaslg', 'fitur']);
    const availableFields = ref([
        {
            val: 'deskripsi',
            label: 'Deskripsi',
        },
        {
            val: 'benefit',
            label: 'Benefit',
        },
        {
            val: 'konfigurasi',
            label: 'Konfigurasi',
        },
        {
            val: 'slaslg',
            label: 'SLA / SLG',
        },
        {
            val: 'fitur',
            label: 'Fitur',
        },
        {
            val: 'contact',
            label: 'Contact',
        },
    ]);
    const loading = ref(false)
    const selectedFields = ref([])
    async function generateWord(id, fields = ['all'], name = null) {
        fields = fields.join(',')
        loading.value = true
        return await axios.post(`https://productcatalog.telkom.co.id/generators/proposal/docx` , {
            data: {
                kode: id,
                menu: fields
            }
        },
        {
            responseType: 'blob'
        })
        .then(res => {
            saveAs(res.data, name.replace(/[(.)]/g, '_') && `Proposal ${name.replace(/[(.)]/g, '_')}`)
        })
        .catch(err => console.error(err))
        .finally(() => loading.value = false)
    }
    return {
        generateWord,
        loading,
        availableFields,
        selectedFields,
    }
}